<template>
    <div v-bind:class="'portlet light bordered tasks-widget margin-bottom-10'" :style="'background:'+ background">
        <div class="portlet-title" v-if="!hideTitle">
            <div class="caption">
                <span class="caption-subject bold uppercase font-dark" style="font-size:15px">{{title}}</span>
                <varientBtn :varientObj="varientObj"></varientBtn><span class="caption-helper"></span>
            </div>
            <div class="actions">
                <slot name="actions"></slot>
                <slot name="tabs"></slot>
                <slot name="iconBtn"></slot>
            </div>
        </div>
        <div class="portlet-body form" style="position:relative">
            <slot></slot>
        </div>
    </div>
</template>
<script>
import VarientBtn from './VarientBtn.vue'
export default {
    components:{
        'varientBtn': VarientBtn,
    },
    props: ['title', 'hideTitle', 'background', 'varientObj'],
}
</script>
